import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { CustomIconsEnum } from '../../enums/custom-icons';

type MaintenanceLinkConfig = {
    link: string;
    linkText: string;
} | null;

/**
 * Currently not used in the project, but can be used in the future to display a maintenance page.
 */
@Component({
    selector: 'apcam-maintenance-page',
    imports: [MatButtonModule, MatIconModule, TranslatePipe],
    templateUrl: './maintenance-page.component.html',
    styleUrl: './maintenance-page.component.scss',
})
export class MaintenancePageComponent implements OnInit {
    protected linkConfig: MaintenanceLinkConfig = null;

    protected readonly CustomIconsEnum = CustomIconsEnum;

    constructor(
        private readonly destroyRef: DestroyRef,
        private readonly route: ActivatedRoute,
        private readonly router: Router
    ) {}

    ngOnInit(): void {
        this.route.data
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((data) => {
                const routerLinkConfig = data['linkConfig'];
                if (routerLinkConfig) this.linkConfig = routerLinkConfig;
            });
    }

    protected navigate(): void {
        if (this.linkConfig) {
            // The link itself is not rendered in HTML if 'linkConfig' is null
            // -> Calling `navigate` method should not be possible
            this.router.navigateByUrl(this.linkConfig.link);
        }
    }
}
